module.exports = __webpack_public_path__ + "img/joinZigZag3.080ca93a.svg";